<template>
  <div class="preview">
    <header>
      <div class="title">发票预览</div>
      <h6>
        <span>{{ getInvoiceImgOrName('name') }}</span>
        <EllipticMark :type="getInvoiceImgOrName('color')" :text="getInvoiceImgOrName('abbr')" />
      </h6>
    </header>
    <main>
      <div class="card">
        <van-field v-model="invoiceOpeningInfo.drewDate" label="开票日期" placeholder="" readonly />
      </div>
      <ModuleHeadText title="购方信息" />
      <div class="card">
        <van-field v-model="invoiceOpeningInfo.purchaserName" label="购方名称" placeholder="" readonly />
        <van-field v-model="invoiceOpeningInfo.purchaserTaxNo" label="纳税人识别号" placeholder="" readonly />
        <template v-if="invoiceOpeningInfo.invoiceType !==7 && invoiceOpeningInfo.invoiceType !==8 ">
          <van-field v-model="invoiceOpeningInfo.purchaserAddress" label="地址、电话" placeholder="" readonly />
          <van-field v-model="invoiceOpeningInfo.purchaserBankName" label="开户行、账号" placeholder="" readonly />
        </template>
        <van-field v-model="invoiceOpeningInfo.purchaserPhone" label="收票人电话" placeholder="" readonly />
        <van-field v-model="invoiceOpeningInfo.purchaserEmail" label="收票人邮箱" placeholder="" readonly />
      </div>
      <ModuleHeadText title="货物或服务清单" />
      <Table
        :tableData="invoiceOpeningInfo.details || []"
        :columns="columns"
        keyField="key"
      >
      </Table>
      <ModuleHeadText title="合计" />
      <div class="card">
        <van-field v-model="invoiceOpeningInfo.amount" label="合计金额" placeholder="" readonly />
        <van-field v-model="invoiceOpeningInfo.taxAmount" label="合计税额" placeholder="" readonly />
        <van-field v-model="invoiceOpeningInfo.amountWithTax" label="价税合计" placeholder="" readonly />
      </div>
      <ModuleHeadText title="销方信息" />
      <div class="card">
        <van-field v-model="company.name" label="销方名称" placeholder="自动填入" readonly />
        <van-field v-model="company.taxId" label="纳税人识别号" placeholder="自动填入" readonly />
        <template v-if="invoiceOpeningInfo.invoiceType !==7 && invoiceOpeningInfo.invoiceType !==8 ">
          <van-field :value="montageField(company.organzationAddress, company.organzationTel)" label="地址、电话" placeholder="自动填入" readonly />
        <van-field :value="montageField(company.directorBankName, company.directorBankNum)" label="开户行、账号" placeholder="自动填入" readonly />
        </template>
      </div>
      <ModuleHeadText title="其他信息" />
      <div class="card">
        <van-field v-model="invoiceOpeningInfo.remark" label="备注" placeholder="" readonly />
        <template v-if="invoiceOpeningInfo.invoiceType !==7 && invoiceOpeningInfo.invoiceType !==8 ">
          <van-field v-model="invoiceOpeningInfo.payee" label="收款人" placeholder="" readonly />
          <van-field v-model="invoiceOpeningInfo.reviewer" label="复核人" placeholder="" readonly />
        </template>
        <van-field v-model="invoiceOpeningInfo.drawer" label="开票人" placeholder="" readonly />
      </div>
    </main>
    <footer>
      <MainButton :handleClick="handleConfirmIssuance">确认开具</MainButton>
    </footer>
  </div>
</template>

<script>
import { Field, Toast } from 'vant'
import { INVOICE_TYPE_IMG_AND_NAME_MAP } from '@/assets/config.js'
import ModuleHeadText from '@/components/ModuleHeadText/index.vue'
import { aesDoEncrypt, isAllElectric } from '@/utils/basicUtil'
import MainButton from '@/components/MainButton/index.vue'
import EllipticMark from '@/components/EllipticMark/index.vue'
import Table from '@/components/Table/index.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    Table,
    MainButton,
    EllipticMark,
    ModuleHeadText,
    [Field.name]: Field,
    [Toast.name]: Toast
  },
  computed: {
    getInvoiceImgOrName () {
      return (type) => {
        let data = ''
        if (INVOICE_TYPE_IMG_AND_NAME_MAP.find(i => i.value === this.invoiceOpeningInfo.invoiceType)) {
          data = INVOICE_TYPE_IMG_AND_NAME_MAP.find(i => i.value === this.invoiceOpeningInfo.invoiceType)[type]
        }
        return data
      }
    },
    invoiceOpeningInfo () {
      return this.$store.state.invoice.invoiceOpeningInfo
    },
    company () {
      return this.$store.state.user.company
    }
  },
  data () {
    return {
      columns: [
        { title: '货物或应税劳务', dataIndex: 'goodsName', width: '107px', type: 'goodName' },
        { title: '含税单价', dataIndex: 'price', width: '69px', align: 'right', type: 'money' },
        { title: '数量', dataIndex: 'quantity', type: 'money' },
        { title: '含税金额', dataIndex: 'amountWithTax', width: '69px', align: 'right', type: 'money' },
        { title: '税率', dataIndex: 'taxRate', type: 'percentage' }
      ]
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions('invoiceOpeningModel', ['invoicing', 'allElectricInvoicing']),
    montageField (a, b) {
      return `${a || ''} ${b || ''}`
    },
    async handleConfirmIssuance () {
      Toast.loading({
        message: '提交中...',
        duration: 0
      })
      try {
        let flag = null
        if (isAllElectric(this.invoiceOpeningInfo.invoiceType)) {
          flag = await this.allElectricInvoicing(this.invoiceOpeningInfo)
        } else {
          flag = await this.invoicing({
            ...this.invoiceOpeningInfo,
            purchaserBankAccount: '',
            purchaserTel: ''
          })
        }
        if (flag) { // 提交成功
          this.$store.commit('invoice/initInvoiceOpeningInfo')
          sessionStorage.removeItem('nowGoodsMessage')
          sessionStorage.removeItem('goods')
          sessionStorage.removeItem('customInfo')
          this.$router.push(`/invoice-opening/result?isOpening=${aesDoEncrypt(true)}`)
        }
      } catch (error) {
        console.error(error)
      } finally {
        Toast.clear({
          clearAll: true
        })
      }
    }
  }
}
</script>

<style lang="less" scoped src="./style.less" />
